// src/pages/FAQPage.jsx
/* global fbq */
import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const FAQPage = () => {
    const [openIndex, setOpenIndex] = useState(null);

    const toggleFAQ = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };
    fbq('track', "User Opened FAQ page");
    window.gtag('event', 'User Opened FAQ Page');


    const faqs = [
        {
            question: "What Are The Main Benefits Of Zenzzz?",
            answer: `
   <p>Zenzzz is a premium sleep supplement created for modern, high-achieving women who value deep rest as part of their wellness routine.</p>
      <ul>
        <li>Supports faster, more restful sleep
        <li>Helps calm the mind and ease nighttime stress</li>
        <li>Encourages full-body relaxation and recovery</li>
        <li>Promotes deep sleep without melatonin or grogginess</li>
        <li>Non-habit forming and designed for nightly use</li>
      </ul>
      Formulated with magnesium glycinate, glycine, valerian root, and chamomile, Zenzzz supports consistent, high-quality sleep so you wake up feeling restored, focused, and balanced.
      `
        },
        {
            question: "Is Zenzzz 3rd Party Tested?",
            answer: `
            </p>Yes. Zenzzz is third-party tested for quality, purity, and safety.</p>

<p>Every batch is independently tested to verify ingredient integrity and ensure it meets strict quality standards. 
Zenzzz is also produced in a GMP-certified facility, reflecting our commitment to clean formulations and elevated wellness.</p>
       `
        },
        {
            question: "Are the ingredients used in the formulation safe?",
            answer:
        `<p>Yes. Zenzzz is formulated using well-researched, trusted ingredients selected for both safety and effectiveness.</p>

<p>Each ingredient: magnesium glycinate, glycine, valerian root, and chamomile has a long history of use in supporting relaxation, stress reduction, and sleep quality. Zenzzz is thoughtfully dosed and designed for nightly use without dependency.</p>

<p>Every batch is third-party tested and manufactured in a GMP-certified facility to ensure purity, consistency, and quality you can trust.</p>`


        },



        {
            question: "Why Doesn’t Zenzzz Use Melatonin?",
            answer: `
            <p>Zenzzz is intentionally melatonin-free to support sleep without disrupting your body’s natural rhythm.</p>

<p>While melatonin can help some people fall asleep, regular use may lead to grogginess, vivid dreams, or reliance over time. Zenzzz instead focuses on calming the nervous system and supporting relaxation naturally so your body can fall asleep on its own.</p>

<p>This approach promotes deeper, more sustainable sleep and a refreshed feeling the next morning, without the side effects commonly associated with melatonin.</p>    
            
            
            `
        },
        {
            question: "Can I take Zenzzz Every Night?",
            answer:
        `<p>Yes. Zenzzz is designed for nightly use.</p>

<p>Its non-habit forming, melatonin-free formula supports relaxation and sleep quality without creating dependence. Zenzzz works best when taken consistently as part of your evening wind-down routine, helping support calm, restorative sleep night after night.</p>`
        },
        {
            question: "How Do I Use Zenzzz?",
            answer: `
            <p>Take Zenzzz 30–60 minutes before bedtime as part of your evening routine.</p>

<p>For best results, pair it with intentional wind-down rituals such as dimming lights, limiting screen time to avoid blue lights, and light stretching to signal your body that it’s time to rest.</p>`
        },
        {
            question: "How Long Does it Take To Feel It?",
            answer: "Most people feel calmer within 30–60 minutes. Full benefits (deeper sleep, waking refreshed) are typically noticed within 3–7 days of consistent use."
        },
        {
            question: "Is Zenzzz Available Internationally?",
            answer: "Currently available in the US only. We’re working on expanding to more countries soon."
        }
    ];

    return (
        <div className="faq-page">
            <div className="container">
                <h1>Frequently Asked Questions</h1>
                <p className="faq-intro">
                    Everything you need to know about Zenzzz. Can’t find an answer?{' '}
                    <Link to="/contact">Contact us</Link>.
                </p>

                <div className="faq-list">
                    {faqs.map((faq, index) => (
                        <div
                            key={index}
                            className={`faq-item ${openIndex === index ? 'open' : ''}`}
                            onClick={() => toggleFAQ(index)}
                        >
                            <div className="faq-question">
                                <h3>{faq.question}</h3>
                                <span className="faq-toggle">
                  {openIndex === index ? '−' : '+'}
                </span>
                            </div>
                            <div className="faq-answer">
                                <div dangerouslySetInnerHTML={{ __html: faq.answer }} />
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default FAQPage;